import * as React from "react";

import { Link, withRouter } from "react-router-dom";
import { connect } from "react-redux";

import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import withStyles from "@material-ui/core/styles/withStyles";

import classNames from "classnames";

const styles = (theme) => ({
  navWrapper: {
    background: `linear-gradient(-134deg, ${theme.palette.grey[100]} 0%, ${theme.palette.grey["A100"]} 100%)`,
    boxShadow: "0 0 10px rgba(0,0,0,0.6)",
    display: "flex",
    flexFlow: "column",
    height: "100%",
    justifyContent: "center",
    left: -150,
    position: "fixed",
    top: 0,
    width: theme.wbiComponent.staticNavigation.totalWidth,
    zIndex: 100,
    transition: theme.transitions.create("left", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    "& > *": {
      // alignSelf: 'center',
      justifyContent: "center",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        alignItems: "inherit",
      },
    },
    "&.visible": {
      left: 40,
      [theme.breakpoints.down("md")]: {
        left: 0,
      },
    },
    [theme.breakpoints.down("lg")]: {
      width: 110,
    },
    "@media print": {
      display: "none",
    },
  },
  nav: {
    left: 0,
    width: '100%',
  },
  navList: {
    textTransform: "uppercase",
    color: theme.palette.grey[600],
    fontSize: 14,
    [theme.breakpoints.down("md")]: {
      fontSize: 12,
      paddingLeft: 26,
    },
    "& li:first-child": {
      [theme.breakpoints.down("md")]: {
        paddingTop: "60px",
      },
    },
    "& li": {
      [theme.breakpoints.down("md")]: {
        paddingTop: "8px",
        paddingBottom: "8px",
      },
      [theme.breakpoints.down("lg")]: {
        paddingLeft: 20,
        fontSize: 13
      },
    },
  },
  navItem: {
    transition: theme.transitions.create("color", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    "&.active": {
      fontWeight: 500,
      color: theme.palette.common.black,
    },
  },
});

class SubNav extends React.Component {
  render() {
    let { classes, items, open, pathname, suffix } = this.props;

    return (
      <React.Fragment>
        <div
          className={classNames(classes.navWrapper, {
            visible: open,
          })}
        >
          <div className={classes.nav}>
            <List className={classes.navList}>
              {items.map((item) => (
                <ListItem
                  key={item.label}
                  className={classNames(classes.navItem, {
                    active:
                      item.isActive ||
                      pathname.toUpperCase() === item.path.toUpperCase(),
                  })}
                >
                  {item.isAvailable ? (
                    <Link to={item.path}>{item.label}</Link>
                  ) : (
                    item.label
                  )}
                </ListItem>
              ))}
            </List>
          </div>
          {suffix}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    app: state.app,
  };
};
export default withRouter(
  withStyles(styles, { withTheme: true })(connect(mapStateToProps)(SubNav))
);



// WEBPACK FOOTER //
// ./src/containers/Cy/components/SubNav/index.jsx